import { render } from "./index.vue?vue&type=template&id=096ddd75&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=096ddd75&lang=less&scoped=true"

import exportComponent from "/Users/Learning/Documents/Workspace/VSCode/HTML/_GitHub/shenwedding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096ddd75"]])

export default __exports__